import { memo, ReactFragment } from "react";

import { StyledEngineProvider } from "@mui/material/styles";

// -----------------------------------------------------------------------------

const GlobalCssPriority = memo(function GlobalCssPriority({
  children,
}: GlobalCssPriorityProps): JSX.Element {
  return <StyledEngineProvider injectFirst>{children}</StyledEngineProvider>;
});

export default GlobalCssPriority;

// -----------------------------------------------------------------------------

interface GlobalCssPriorityProps {
  children: ReactFragment;
}
